<template>
    <div class="record-board-container">
        <Title :strong="2">榜单</Title>
        <div  v-if="competition" class="unshow-info">
            <a-alert type="info" show-icon>
                <span slot="description">-- 比赛塔不显示成绩 --</span>
            </a-alert>
        </div>
        <Endings v-else-if="flatDifficulty" :endings="record[0].endings" />
        <a-collapse v-else v-model="activeDifficulty" :bordered="false">
            <a-collapse-panel
                v-for="difficulty of record" :key="difficulty.label"
                :header="difficulty.label"
            >
                <Endings :endings="difficulty.endings" />
            </a-collapse-panel>
        </a-collapse>
    </div>
</template>

<script>
import Title from '@/components/Title.vue'
import Endings from '../components/Endings.vue'
import { default as AAlert } from 'ant-design-vue/es/alert';

export default {
    props: {
        record: Array,
        competition: { type: Boolean, default: false }
    },
    data: () => ({
        activeDifficulty: [],
    }),
    computed: {
        flatDifficulty() {
            if (this.record.length === 1 && this.record[0].label === '') {
                return true;
            } else {
                return false;
            }
        },
    },
    created() {
        this.activeDifficulty = this.record
            .filter(e => (Number(e.fold) === 0))
            .map(e => e.label);
    },
    components: {
        Title, Endings, AAlert,
    },
}
</script>

<style lang="less" scoped>
.record-board-container {
    text-align: left;
}
.unshow-info {
    margin: 10px;
}
</style>
